import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/css/bootstrap.min.css';
import '@/css/bootstrap-theme.min.css';
import '@/css/general2.css';
import '@/css/est.css';

createApp(App).use(router).mount('#app')
